import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["extensions", "value", "selection", "onChange"];
import { useEffect } from 'react';
import { getDefaultExtensions } from '@uiw/react-codemirror';
import { useStore } from './store';
export var Modified = props => {
  var {
      extensions = [],
      value,
      selection,
      onChange
    } = props,
    otherOption = _objectWithoutPropertiesLoose(props, _excluded);
  var {
    theme,
    dispatch
  } = useStore();
  var defaultExtensions = getDefaultExtensions(_extends({}, otherOption, {
    theme
  }));
  useEffect(() => {
    dispatch({
      modified: {
        doc: value,
        selection: selection,
        extensions: [...defaultExtensions, ...extensions]
      },
      modifiedExtension: {
        onChange,
        option: otherOption,
        extension: [extensions]
      }
    });
  }, [props]);
  return null;
};
Modified.displayName = 'CodeMirrorMerge.Modified';